import fetch from "auth/FetchInterceptor";

const AuthService = {};

AuthService.login = function (data) {
  return fetch({
    url: "/v1/login",
    method: "post",
    data: data,
  });
};

AuthService.register = function (data) {
  return fetch({
    url: "/v1/auth/register",
    method: "post",
    data: data,
  });
};

AuthService.logout = function () {
  return fetch({
    url: "/v1/auth/logout",
    method: "post",
  });
};

AuthService.loginInOAuth = function () {
  return fetch({
    url: "/v1/auth/loginInOAuth",
    method: "post",
  });
};

AuthService.forgotPass = function (data) {
  return fetch({
    url: "/v1/forget-password",
    method: "post",
    data: data,
  });
};

export default AuthService;
